
const sectors = {
    CHAREDI: 'CHAREDI',
    KLALI: 'KLALI',
    NEUTRAL: "NEUTRAL"
}

const sectorOptions = [
    { id: sectors.KLALI, name: "כללי" },
    { id: sectors.CHAREDI, name: "חרדי" },
    { id: sectors.NEUTRAL, name: "נייטרלי" },
]

export { sectorOptions }
export default sectors